import { __extends } from "tslib";
import React from 'react';
import { Validation, Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '../Modules/Types';
var ValidationSummary = /** @class */ (function (_super) {
    __extends(ValidationSummary, _super);
    function ValidationSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        return _this;
    }
    ValidationSummary.prototype.getRules = function (modelInfo) {
        return modelInfo.objectDisplayInfo.concat(modelInfo.propertyRules)
            .sort(function (a, b) { return a.order === b.order ? 0 : (a.order > b.order ? 1 : -1); })
            .sort(function (a, b) { return a.displayInfo.severity === b.displayInfo.severity ? 0 : (a.displayInfo.severity > b.displayInfo.severity ? -1 : 1); });
    };
    ValidationSummary.prototype.render = function () {
        var _this = this;
        var graph = this.props.graph;
        if (graph === undefined) {
            if (this.props.model) {
                graph = Validation.getValidationSummary(this.props.model, Validation.DisplayMode.Always);
            }
            else {
                throw Error("ValidationSummary expects 'graph' or 'model' property to be provided.");
            }
        }
        var models = graph instanceof Array ? graph : [graph];
        return (React.createElement("div", { className: "validation-summary" }, graph && models.map(function (modelInfo, index) { return (React.createElement("div", { key: index, className: "validation-summary-model" },
            _this.props.hideTopLevelTitle !== true &&
                React.createElement("div", { className: "validation-summary-model-title" },
                    _this.iconFactory.getIconComponent(modelInfo.model.getIcon()),
                    " ",
                    modelInfo.model.toString()),
            React.createElement("div", { className: "validation-summary-model-body" + (_this.props.hideTopLevelTitle === true ? " no-title" : "") },
                React.createElement("div", { className: "validation-summary-model-rules" }, _this.getRules(modelInfo).map(function (rule, index) { return (React.createElement("div", { key: index, className: rule.displayInfo.additionalClassName },
                    _this.iconFactory.getIconComponent(rule.displayInfo.icon, { fixedWidth: true, spin: !!rule.displayInfo.asyncBusyText }),
                    " ",
                    rule.displayInfo.displayText)); })),
                React.createElement(ValidationSummary, { graph: modelInfo.valueObjects }),
                React.createElement(ValidationSummary, { graph: modelInfo.childObjects }),
                React.createElement(ValidationSummary, { graph: modelInfo.childLists })))); })));
    };
    return ValidationSummary;
}(React.Component));
export default ValidationSummary;
